// colors.js
export const defaultThemeColors = {
    brand: "#411F2D",
    black: "#000000",
    primary: "#06D6A0",
    secondary: "#26547C",
    tertiary: "#FFD166",
    error: "#EF476F",
};